import { gql } from "@apollo/client";

export const GET_PEOPLE = gql`
  query GetPeople($input: BackofficeCRMPeopleInput!) {
    people(input: $input) {
      nodes {
        id
        pgaId
        displayName
        profilePhoto
        phoneNumbers {
          phoneNumber
        }
      }
    }
  }
`;

export const PAT_UPSERT_SUBMISSION_MUTATION = gql`
  mutation PatUpsertSubmission($input: PATSubmissionInput!) {
    patUpsertSubmission(input: $input) {
      success
      message
      submission {
        id
        result
        totalScore
        roundOne {
          roundScore
        }
        roundTwo {
          roundScore
        }
        additionalStatus
        note
      }
    }
  }
`;

export const PAT_FINALIZE_SCORES_MUTATION = gql`
  mutation PATFinalizeScores($id: ID!) {
    patFinalizeScores(id: $id) {
      message
      success
    }
  }
`;

export const PAT_EDIT_SUBMISSION_MUTATION = gql`
  mutation PATEditSubmission($input: PATEditSubmissionInput!) {
    patEditSubmission(input: $input) {
      message
      success
    }
  }
`;

export const PAT_STATUS_COUNTS_QUERY = gql`
  query GetStatusCounts($eventId: ID!) {
    statusCounts(eventId: $eventId) {
      cheatingCount
      disqualifiedCount
      excusedCount
      excessiveCount
      failingCount
      invalidCount
      medicalWithdrawalCount
      noCardCount
      noShowCount
      passingCount
      poorConductCount
      qualifyingCount
      weatherEventCount
      withdrawalCount
      missingStatusCount
    }
  }
`;
